class DashboardReducerActionTypes {}
DashboardReducerActionTypes.FETCH_DASHBOARD_RESPONSE = "FETCH_DASHBOARD_RESPONSE"
DashboardReducerActionTypes.RESET_DASHBOARD_DATES = "RESET_DASHBOARD_DATES"
DashboardReducerActionTypes.DASHBOARD_LIST_LOADING = "DASHBOARD_LIST_LOADING"
DashboardReducerActionTypes.DASHBOARD_DATEPICKER_DATES_SELECTED = "DASHBOARD_DATEPICKER_DATES_SELECTED"
DashboardReducerActionTypes.ROLLBACK_DASHBOARD_PAGE = "ROLLBACK_DASHBOARD_PAGE"
export default DashboardReducerActionTypes
